<template>
    <div
        class="kita-karte w-full border border-radius border-gray-100 shadow-inner xl:h-screen"
    >
        <l-map
            :zoom="zoom"
            :min-zoom="minZoom"
            :max-zoom="maxZoom"
            :center="center"
            :options="options"
        >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <v-marker-cluster>
                <l-marker
                    :lat-lng="marker.latlng"
                    v-for="marker in markers"
                    :key="marker.id"
                    :icon="marker.icon"
                >
                    <l-popup :content="marker.tooltip" />
                </l-marker>
            </v-marker-cluster>
        </l-map>
    </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import "./plugins/Leaflet.Icon.Glyph.js";

export default {
    name: "kita-karte",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip,
        "v-marker-cluster": Vue2LeafletMarkerCluster
    },
    data() {
        return {
            // url: 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png', //german
            url:
                "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            zoom: 8.2,
            minZoom: 7,
            maxZoom: 18,
            center: [54.024912, 11.499527],
            bounds: null,
            nurseries: [],
            markers: [],
            dayCares: [],
            options: {
                scrollWheelZoom: false
            },
            icon: L.icon.glyph({ prefix: "fa", glyph: "child" })
        };
    },
    mounted() {
        this.openSearchModal();
        this.fetchNurseries();
        this.fetchDayCares();
    },
    methods: {
        openSearchModal() {
            const searchModal = document.getElementById("searchModal");
        },
        zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        centerUpdated(center) {
            this.center = center;
        },
        boundsUpdated(bounds) {
            this.bounds = bounds;
        },
        setMarkers(places, glyphColor = "white") {
            if (places.length >= 0) {
                const startId = this.markers.length - 1;
                for (let i = 0, len = places.length; i < len; i++) {
                    if (places[i]["addresses"].length >= 0) {
                        for (
                            let j = 0, len2 = places[i]["addresses"].length;
                            j < len2;
                            j++
                        ) {
                            let lat = places[i]["addresses"][j]["lat"];
                            let lng = places[i]["addresses"][j]["lng"];
                            let city = places[i]["addresses"][j]["city"];
                            let street = places[i]["addresses"][j]["street"];
                            let postCode =
                                places[i]["addresses"][j]["post_code"];
                            this.markers.push({
                                id: startId + i,
                                tooltip: `<h3 class="font-sans font-bold">${places[i].title}</h3><p>${street}<br>${postCode} ${city}</p>`,
                                latlng: [lat, lng],
                                icon: L.icon.glyph({
                                    prefix: "fa",
                                    glyph: "child",
                                    glyphColor: glyphColor
                                })
                            });
                        }
                    }
                }
            }
        },
        fetchDayCares() {
            axios.get("/api/day-cares").then(response => {
                this.dayCares = response.data;
                this.setMarkers(this.dayCares, "#f8cb00");
                // console.log('day-cares added')
            });
        },
        fetchNurseries() {
            axios.get("/api/nurseries").then(response => {
                this.nurseries = response.data;
                this.setMarkers(this.nurseries, "#e83e8c");

                // console.log('nurseries added')
            });
        }
    }
};
</script>

<style lang="scss">
@import "leaflet.markercluster/dist/MarkerCluster.css";
@import "leaflet.markercluster/dist/MarkerCluster.Default.css";

.kita-karte {
    .marker-cluster-small {
        background-color: rgba(24, 188, 156, 0.6);
        // background-color: rgba(181, 226, 140, 0.6);
    }

    .marker-cluster-small div {
        // background-color: rgba(110, 204, 57, 0.6);
        background-color: rgb(24, 188, 156);
    }

    .marker-cluster-medium {
        background-color: rgba(241, 211, 87, 0.6);
    }

    .marker-cluster-medium div {
        background-color: rgba(240, 194, 12, 0.6);
    }

    .marker-cluster-large {
        background-color: rgba(253, 156, 115, 0.6);
    }

    .marker-cluster-large div {
        background-color: rgba(241, 128, 23, 0.6);
    }

    /* IE 6-8 fallback colors */
    .leaflet-oldie .marker-cluster-small {
        background-color: rgb(181, 226, 140);
    }

    .leaflet-oldie .marker-cluster-small div {
        // background-color: rgb(110, 204, 57);
        background-color: rgb(24, 188, 156);
    }

    .leaflet-oldie .marker-cluster-medium {
        background-color: rgb(241, 211, 87);
    }

    .leaflet-oldie .marker-cluster-medium div {
        background-color: rgb(240, 194, 12);
    }

    .leaflet-oldie .marker-cluster-large {
        background-color: rgb(253, 156, 115);
    }

    .leaflet-oldie .marker-cluster-large div {
        background-color: rgb(241, 128, 23);
    }
}
</style>
